import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=9887aafa&scoped=true"
import script from "./Slideshow.vue?vue&type=script&lang=js"
export * from "./Slideshow.vue?vue&type=script&lang=js"
import style0 from "./Slideshow.vue?vue&type=style&index=0&id=9887aafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9887aafa",
  null
  
)

export default component.exports